import { render, staticRenderFns } from "./CompactHeaderMenu.vue?vue&type=template&id=23b963a1&scoped=true"
import script from "./CompactHeaderMenu.vue?vue&type=script&lang=js"
export * from "./CompactHeaderMenu.vue?vue&type=script&lang=js"
import style0 from "./CompactHeaderMenu.vue?vue&type=style&index=0&id=23b963a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b963a1",
  null
  
)

export default component.exports